import React from "react";
import MultiplePizzas from "../assets/multiplePizzas.jpeg";
import "../styles/About.css";
import { motion } from "framer-motion";

const barVariant = {
  hidden: { width: 0, x: "-100%" },
  visible: (i) => ({
    width: "100vw",
    x: 0,
    transition: {
      duration: 0.7,
      delay: i * 0.3, // stagger bars
      ease: [0.25, 0.8, 0.25, 1],
    },
  }),
};

function About() {
  return (
    <motion.div
      className="about"
      initial={{ opacity: 0, y: 30, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -20, scale: 0.95 }}
      transition={{
        duration: 0.6,
        ease: [0.25, 0.8, 0.25, 1],
      }}
    >
      {/* Top Animated Bars */}
      <motion.div
        className="animated-bar red"
        custom={0}
        variants={barVariant}
        initial="hidden"
        animate="visible"
      />
      <motion.div
        className="animated-bar orange"
        custom={1}
        variants={barVariant}
        initial="hidden"
        animate="visible"
      />
      <motion.div
        className="animated-bar yellow"
        custom={2}
        variants={barVariant}
        initial="hidden"
        animate="visible"
      />

      {/* Hero Section with Background */}
      <div
        className="aboutTop"
        style={{ backgroundImage: `url(${MultiplePizzas})` }}
      >
        <div className="overlay">
          <h1 className="heroTitle">We Craft Pizza With Passion</h1>
        </div>
      </div>

      {/* Middle Animated Bars */}
      <motion.div
        className="animated-bar orange"
        custom={3}
        variants={barVariant}
        initial="hidden"
        animate="visible"
      />
      <motion.div
        className="animated-bar yellow"
        custom={4}
        variants={barVariant}
        initial="hidden"
        animate="visible"
      />

      {/* Content Section */}
      <div className="aboutBottom">
        <div className="contentCard">
          <h2>About Us</h2>
          <p>
            Welcome to our pizzeria, where tradition meets flavor. Each pizza is
            handcrafted using time-honored recipes, the finest local ingredients,
            and a whole lot of love. Whether you're craving classic Margherita or
            daring new creations, we’ve got you covered.
            <br />
            <br />
            Our chefs bring generations of culinary expertise to your table, and our
            cozy atmosphere is perfect for families, friends, and celebrations. Join
            us to discover what makes us more than just a restaurant — we’re a
            community.
          </p>
        </div>
      </div>

      {/* Bottom Animated Bar */}
      <motion.div
        className="animated-bar red"
        custom={5}
        variants={barVariant}
        initial="hidden"
        animate="visible"
      />
    </motion.div>
  );
}

export default About;
